<template>
  <div class="relative mx-auto max-w-[var(--breakpoint-xl)] px-4 sm:px-8">
    <section class="mx-auto mt-12 max-w-prose lg:max-w-none">
      <div
        v-if="!isLoading && changelog.length === 0"
        class="text-center text-neutral-400"
      >
        There are currently no entries in this changelog.
      </div>
      <div class="mx-auto max-w-[var(--breakpoint-xl)] space-y-6">
        <LazyMarketingCardChangelog
          v-for="(log, index) in changelog"
          v-if="!isLoading && changelog.length > 0"
          :key="index"
          :log="log"
        />
        <LazyMarketingCardChangelogLoading
          v-for="i in perPage"
          v-if="isLoading"
          :key="i"
        />

        <UCard
          v-if="totalItems > perPage"
          :ui="{
            root: 'bg-neutral-900/40 backdrop-blur-lg w-fit mx-auto mt-4',
            body: 'p-1 sm:p-1',
          }"
        >
          <UPagination
            v-model:page="currentPage"
            :total="totalItems"
            :items-per-page="perPage"
            :default-page="1"
            :show-edges="true"
            :sibling-count="1"
            @update:page="handlePageChange"
          />
        </UCard>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import type { ListChangelogStoryblok } from '~/types/component-types-sb';

const { fetchChangelog, totalItems, isLoading } = useStoryblokClient();

defineProps<{
  blok: ListChangelogStoryblok;
  uuid?: string;
  type?: string;
}>();

const changelog = ref<any[]>([]);
const currentPage = ref(1);
const perPage = ref(5);

// Load changelog and set them in the reactive `changelog` array
const loadChangelog = async (page: number, perPage: number) => {
  try {
    const [stories] = await Promise.all([fetchChangelog(page, perPage)]);
    changelog.value = stories;
  } catch (error) {
    console.error(error);
  }
};

// Handle page change
const handlePageChange = async (page: number) => {
  await loadChangelog(page, perPage.value);
  // Optionally scroll to top of the page
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

// Initial load
onMounted(async () => {
  await loadChangelog(currentPage.value, perPage.value);
});
</script>
